import React, { useState, useEffect } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../lib/firebase';
import {logAuditAction} from '../lib/auditLogger';
import Spinner from '../components/Spinner';
import { useAuth } from '../contexts/AuthContext';
import Modal from '../components/Modal';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState({ show: false, message: '' });
    const navigate = useNavigate();
    const { user, loading } = useAuth();
    useEffect(() => { if (user && !loading) navigate("/dashboard", { replace: true }); }, [user, loading, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        
        if (!email || !password) {
            setModal({ show: true, message: 'Please enter both email and password.' });
            return;
        }

        setIsLoading(true);

        try {
            const credential=await signInWithEmailAndPassword(auth, email.trim(), password);
            void logAuditAction(credential.user,'SIGN_IN','Signed in to the platform');
            


        } catch (error) {
            console.error("Login Error:", error);
            setModal({ show: true, message: error.code === 'auth/too-many-requests' ? 'Too many attempts. Please wait a moment and try again.' : error.code === 'auth/network-request-failed' ? 'Check your internet connection and try again.' : 'We could not sign you in. Check your email and password.' });
            setIsLoading(false); // Stop loading only on error
        }
        // Note: We do NOT set isLoading(false) on success, 
        // so the spinner keeps showing until the page changes.
    };

    return (
        <div className="login-shell min-h-screen flex items-center justify-center p-5">
            {modal.show && <Modal message={modal.message} onClose={() => setModal({ show: false })} />}
            <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-md">
                
                {/* Logo Section */}
                <div className="flex justify-center mb-4">
                    <img 
                        src="https://firebasestorage.googleapis.com/v0/b/exam-platform-v2.firebasestorage.app/o/public%2FInstill%20logo%20copy.png?alt=media&token=811c3b74-7d3d-4988-9310-dbc0e8267304" 
                        alt="Instil Learning Hub Logo" 
                        className="w-28 h-28" 
                    />
                </div>

                <h2 className="text-3xl font-bold text-center text-pink-800 mb-2">Instil Learning Hub</h2>
                <p className="text-center text-gray-500 mb-6">A little progress today. A stronger you tomorrow.</p>
                
                <form onSubmit={handleLogin}>
                    <div className="mb-4">
                        <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">Email Address</label>
                        <input 
                            id="email" autoComplete="username" required type="email" 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)} 
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400" 
                            placeholder="you@example.com" 
                        />
                    </div>
                    <div className="mb-6">
                        <label htmlFor="password" className="block text-gray-700 text-sm font-bold mb-2">Password</label>
                        <input 
                            id="password" autoComplete="current-password" required type="password" 
                            value={password} 
                            onChange={(e) => setPassword(e.target.value)} 
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400" 
                            placeholder="••••••••" 
                        />
                    </div>
                    <button 
                        type="submit" 
                        disabled={isLoading} 
                        className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold py-2 px-4 rounded-lg hover:from-purple-700 hover:to-pink-700 transition duration-300 disabled:from-purple-300 disabled:to-pink-300 flex items-center justify-center h-10"
                    >
                        {isLoading ? <Spinner /> : 'Log In'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;